import React, { useState } from 'react';
import { isSoundMuted, toggleSound } from '../utils/soundEffects';
import './MuteToggleButton.css';

export const MuteToggleButton: React.FC = () => {
  const [muted, setMuted] = useState(isSoundMuted);

  const handleToggle = () => {
    setMuted(toggleSound());
  };

  return (
    <button
      className="mute-toggle-trigger"
      onClick={handleToggle}
      aria-label={muted ? 'Activar sonido' : 'Silenciar sonido'}
      aria-pressed={muted}
      title={muted ? 'Activar sonido' : 'Silenciar sonido'}
    >
      {muted ? (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
        </svg>
      ) : (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
      )}
    </button>
  );
};
